import {appStore} from "./AppStore";
import {observable} from "mobx";

class LooseLeafFormStore {
    @observable looseLeafSeed = {};
}

export default new LooseLeafFormStore();
